<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-plane"></i
                ><strong> Formulario Inspección</strong>
                <div class="card-header-actions">
                  <small class="text-muted">-</small>
                </div>
              </div>
              <form-wizard
                color="#20a8d8"
                errorColor="#f86c6b"
                ref="wizard"
                nextButtonText="Siguiente"
                backButtonText="Atrás"
                finishButtonText="Finalizar"
                @on-complete="onComplete"
                title=""
                @on-change="renewInfo"
                subtitle=""
              >
                <tab-content
                  title="Datos Inspección"
                  :before-change="submitFormInspeccion"
                >
                  <formInspeccion
                    :inspeccion="inspeccion"
                    ref="formInspeccion"
                  ></formInspeccion>
                </tab-content>

                <tab-content
                  title="Datos Pallet"
                  :before-change="terminarYGuardar"
                >
                  <formInspeccionPallet
                    :destination="inspeccion.destination"
                    :inspeccion="inspeccion"
                    ref="formInspeccionPallet"
                  ></formInspeccionPallet>
                </tab-content>
              </form-wizard>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import formInspeccion from "./formInspeccion.vue";
import formInspeccionPallet from "./formInspeccionPallet.vue";

import { shuffleArray } from "@/shared/utils";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { bus } from "../../main";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "Inspeccion",
  components: {
    formInspeccion,
    formInspeccionPallet
  },
  mounted() {
    // this.boardingSaved = false;
    // if (this.BoardingID != null )
    // {
    //   this.loadBoarding(this.BoardingID);
    //   this.boardingSaved= true;
    // }else{
    // }
  },
  props: ["InspeccionID"],
  data() {
    return {
      inspeccionSaved: false,
      inspeccion: {
        id: "",
        sif_number: "",
        sif_date: "",
        inspection_list: [],
        sag_worker: "",
        product: "",
        plant: "",
        destination_country: "",
        destination: "",
        countries: ""
      }
    };
  },
  computed: {},
  methods: {
    loadBoarding(a) {},
    submitFormInspeccion() {
      var formValidacion = this.$refs.formInspeccion.saveForm();
      if (formValidacion == 0) {
        this.$swal.fire(
          "Campos requeridos o invalidos en el formulario",
          "",
          "warning"
        );
        return false;
      } else {
        this.$refs["formInspeccionPallet"].getPallet(
          this.inspeccion.destination
        );
        return true;
      }
    },

    terminarYGuardar() {
      this.$swal
        .fire({
          title: "Seguro que quieres terminar?",
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "SI"
        })
        .then((result) => {
          if (result.value) {
            if (this.inspeccionSaved == false) {
              var padre = this;

              var objPallets = this.$refs.formInspeccionPallet.getpalletscheck();
              var arrayPallets = [];

              if (Object.keys(objPallets).length > 0) {
                for (var i = 0; i < Object.keys(objPallets).length; i++) {
                  arrayPallets[i] = objPallets[i].id;
                }

                this.$axios
                  .post("/api/comex/inspection/", this.inspeccion)
                  .then((res) => {
                    const formData = {
                      pallets: arrayPallets
                    };

                    padre.$axios
                      .put(
                        "/api/comex/inspection/" +
                          res.data.id +
                          "/set_packing_list/",
                        formData
                      )
                      .then((res) => {
                        padre.$swal.fire(
                          "Operación realizada con éxito",
                          "",
                          "success"
                        );

                        padre.$router.push("/exportacion/lista-inspeccion/");

                        return true;
                      })
                      .catch((error) => {
                        padre.$swal.fire(
                          "Problemas al terminar proceso",
                          "",
                          "error"
                        );

                        return false;
                      });
                  })
                  .catch((error) => {
                    padre.$swal.fire(
                      "Problemas al terminar proceso",
                      "",
                      "error"
                    );

                    return false;
                  });
              } else {
                padre.$swal.fire(
                  "Por favor seleccione por lo menos un pallet",
                  "",
                  "info"
                );
              }

              // estoy editando
            } else {
              /*   var padre=this;

               

           this.$axios.put('/api/comex/shipment/update_shipping/', this.boarding)
           .then(res => {

             const formData = {
             boarding_id: res.data.id,
             shipping_detail: this.boarding.shipping_detail,
             client: this.$store.getters.user.ID_CLIENTE
           }; 

             padre.$axios.put('/api/comex/companyform/update_shipping_detail/', formData)
           .then(res => {

              padre.$swal.fire(
           "Operación realizada con éxito",
           "",
           "success"
         );

         padre.$router.push("/");
          
           return true;




               })
             .catch(error => {
                      padre.$swal.fire(
           "Problemas al terminar proceso",
           "",
           "error"
           );

           return false;
                   });

        

         })
        .catch(error => {

          padre.$swal.fire(
           "Problemas al terminar proceso",
           "",
           "error"
           );

           return false;
         }); */
            }
          } else {
          }
        });
    },
    renewInfo: function (prevIndex, nextIndex) {},
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
